<template>
  <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25 39L20 34M25 39L30 34M25 39V24M25 24H40M25 24V17M25 24H18M40 24L35 19M40 24L35 29"
      stroke="var(--sf-illustration-primary-background-primary)"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 7L17 12M22 7L27 12M22 7V22M22 37L17 32M22 37L27 32M22 37V22M22 22H37M22 22H7M37 22L32 17M37 22L32 27M7 22L12 17M7 22L12 27"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
